/* 
eslint-disable no-mixed-operators
*/
import React from 'react';
import SwitchScreen from '../../types/switch';
import DynamicScreen from './';

const DynamicSwitchScreen = React.memo(
	({descriptor, onTemplate, activeTemplate, ...props}) => {
		const {type, field, value,  ...screenDescriptors} = descriptor;
		const screenOptions = Object.keys(screenDescriptors).reduce((acc, key) => {
			const screenDescriptor = screenDescriptors[key];
			const screen = <DynamicScreen descriptor={screenDescriptor} onTemplate={onTemplate} activeTemplate={activeTemplate} />
			return {...acc, [key]:screen};
		}, {})
		return <SwitchScreen {...props} field={field} value={value} {...screenOptions} />
	}
);

export default DynamicSwitchScreen;